<template>
  <div name="pupils">
    <div name="innertopbar" class="flex pt-4 pb-6 mx-6">
      <div
        class="w-14 h-14 mt-1 mr-2 text-center content-center rounded-2xl p-3 cursor-pointer hover:opacity-50"
        v-bind:style="{ backgroundColor: getBackgroundColor }"
      >
        <div class="icon bg-white rounded-xl w-8 h-8 p-1">
          <img :src="contentImage" class="w-6 h-6" />
        </div>
      </div>

      <div
        class="text-black text-xl font-bold w-1/2 pt-4 pl-2 capitalize text-left"
      >
        {{ title }} Health Measures - {{ selectedDataType.title }}
      </div>

      <div class="text-right w-2/3 pr-4">
        <ul class="mt-1 md:w-11/12 md:ml-6 inline-block">
          <li class="inline-block">
            <ClassDropdown
              :classSelected="filterValue.group"
              @classValueChanged="updateFilteredClass"
            ></ClassDropdown>
            <!-- <dropdown
              v-if="classes.length > 0"
              :options="classDropdown"
              :selected="selectedClass"
              v-on:updateOption="updateFilteredClass"
              class="filter-bar-button bg-opacity-75 hover:bg-opacity-50 w-48 text-center"
            ></dropdown> -->
          </li>

          <li class="inline-block">
            <button
              type="button"
              class="filter-bar-button focus:outline-none hover:opacity-75"
              v-bind:class="
                filterHasValues ? 'filter-item-button-on' : 'bg-white'
              "
              @click="showFilter()"
            >
              <i class="fas fa-filter"></i> Filters
            </button>
          </li>

          <li class="inline-block mx-4 text-2xl text-gray-400">|</li>

          <li class="inline-block" @click="closeWindow()">
            <i class="fas fa-times close-icon text-1xl" title="Close"></i>
          </li>
        </ul>
      </div>
    </div>

    <PupilFilterModal
      class=""
      v-if="filterIsVisible"
      :values="filterValue"
      @apply-filter="applyFilter"
      @close="showFilter"
    >
    </PupilFilterModal>

    <div class="flex p-4 w-full mx-auto bg-gray-200">
      <div class="w-full mt-1 pt-3 pb-4 bg-white px-2 rounded-lg">
        <p v-if="showMessage" class="save-notice ml-6 mb-6 font-bold">
          {{ msg }} <i class="far fa-check-circle"></i>
        </p>

        <div class="flex justify-between pb-6">
          <button
            class="bg-indigo-600 bg-opacity-75 hover:bg-indigo-700 text-white font-bold p-3 mt-2 mb-1 ml-2 rounded-md"
            @click="moveToday"
          >
            {{ selectedMonthTitle }}
          </button>

          <div class="pr-3">
            <ul>
              <li
                v-for="dtype in dataTypes"
                :key="dtype.id"
                class="inline-block"
              >
                <button
                  class="hover:opacity-50 pt-3 px-3 mb-1 text-2xl focus:outline-none"
                  v-bind:class="
                    selectedDataType.id === dtype.id
                      ? 'text-indigo-600'
                      : 'text-gray-300'
                  "
                  @click="changeSelectedDataType(dtype)"
                >
                  <i class="fas" :class="dtype.icon"></i>
                </button>
              </li>
            </ul>
          </div>
        </div>

        <table
          class="w-full mx-auto mb-2 h-14 pt-2 align-text-bottom bg-white rounded text-left text-gray-400"
        >
          <thead class="w-full">
            <tr>
              <th class="pl-2 w-3/12">
                Pupil Name
                <i
                  class="fas fa-sort tbh-sort"
                  v-bind:class="
                    'name' === sortBy ? 'text-blue-500' : 'text-gray-400'
                  "
                ></i>
              </th>
              <th
                v-for="cal in weekView"
                :key="cal.dateOfDay"
                class="text-xs text-center"
                style="min-width: 2.5; max-width: 2.5em"
              >
                <div
                  class="flex group bg-opacity-75 rounded-lg mx-auto cursor-pointer justify-center w-10/12"
                  v-bind:class="
                    isSelectedDate(cal.date)
                      ? 'bg-indigo-600 text-white '
                      : 'bg-gray-300 text-gray-800 '
                  "
                >
                  <div class="flex items-center px-4 py-1">
                    <div class="text-center">
                      <p class="group-hover:text-gray-500 text-sm">
                        {{ cal.dayOfWeek }}
                      </p>
                      <p
                        class="group-hover:text-gray-500 group-hover:font-bold"
                      >
                        {{ cal.dateOfDay }}
                      </p>
                    </div>
                  </div>
                </div>
              </th>
            </tr>
          </thead>
        </table>

        <div class="table-wrapper">
          <div v-if="errored" class="empty ml-10 mt-4">
            <p>
              We are not able to retrieve this information at the moment, please
              try back later
            </p>
          </div>

          <div id="content-area" v-else>
            <div
              style="width: 100%; text-align: center"
              class="spin-holder mt-4"
              v-if="loading"
            >
              <i class="spinner fa fa-spinner fa-spin"></i>
              <p>Loading Pupils</p>
            </div>

            <div v-else>
              <table
                v-if="componentLoaded"
                class="table-wrapper mx-auto bg-white w-full rounded shadow-sm"
              >
                <tbody>
                  <tr v-for="item in filteredList" :key="item.pupil.identifier">
                    <td class="w-3/12">
                      <span class="pl-3"> {{ item.pupil.name }}</span>
                    </td>
                    <td
                      class="text-xs text-center w-2 border-2 border-gray-200"
                      style="max-width: 1em"
                      v-for="(day, col) in weekView"
                      :key="day.dateOfDay"
                      :class="
                        colIsEven(col)
                          ? 'bg-gray-100 bg-opacity-50'
                          : 'bg-white bg-opacity-25'
                      "
                    >
                      <div class="flex">
                        <!-- <div class="flex flex-col pl-3">
                          <i
                            @click="addToCount"
                            class="fas fa-chevron-up count-button"
                          ></i>
                          <i
                            @click="removeFromCount"
                            class="fas fa-chevron-down count-button"
                          ></i>
                        </div> -->
                        <div class="text-center w-10/12 mx-auto">
                          <input
                            v-on:change="handleFocusout($event, item, day)"
                            :value="presetValue(item.measures, day)"
                            type="number"
                            class="font-semibold opacity-75 bg-transparent h-8 text-center rounded"
                            v-bind:class="
                              presetValue(item.measures, day) > 0
                                ? 'w-7/12 text-base'
                                : 'w-full text-lg  pl-3'
                            "
                          />
                          <div
                            class="inline text-right ml-3 text-xl w-3/12 leading-none hover:opacity-50 cursor-pointer"
                            v-if="presetValue(item.measures, day) > 0"
                            @click="addSelfAssess(item, day)"
                          >
                            <i
                              class="fa-heart text-red-500"
                              :class="hasFeeling(item, day) ? 'fas' : 'far'"
                            ></i>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <p class="m-5 mx-12" v-else>
                We could not find any data for your given selection.
              </p>
            </div>

            <div class="w-full mx-auto">
              <Pagination
                v-if="componentLoaded"
                :total-pages="totalPages"
                :total="totalResultsCount"
                :current-page="currentPage"
                :has-more-pages="hasMorePages"
                :pageSize="pageSize"
                @pagechanged="showMore"
                class="mt-4 mb-12"
              >
              </Pagination>
            </div>
          </div>
        </div>
      </div>

      <div class="w-1/4 rounded-lg bg-white ml-3 p-2">
        <v-calendar
          :attributes="dates"
          expanded
          trim-weeks
          :first-day-of-week="2"
          show-iso-weeknumbers
          class="w-full border-0 mt-1"
          @dayclick="dayClick"
        >
          <template #footer>
            <div class="w-full px-4 pb-3">
              <button
                class="bg-indigo-600 hover:bg-indigo-700 text-white font-bold w-full px-3 mt-2 py-2 rounded-md"
                @click="moveToday"
              >
                Today
              </button>
            </div>
          </template>
        </v-calendar>
      </div>
    </div>

    <ModalSlide :show="showModalSelfAssess" @closeModal="closeSelfAssess">
      <template v-slot:header-icon>
        <i class="fas fa-plus"></i>
      </template>
      <template v-slot:header-title>
        How are you feeling?
        <div class="text-xs">
          Tell us about your mood and your thoughts on how you feel.
        </div>
      </template>
      <template v-slot:body>
        <MeasureFeeling
          v-if="selectedPupil != undefined"
          :pupil="selectedPupil"
          :measurement="selectedMeasurement"
          :workout="workout"
          :feeling="selectedFeeling"
          @feeling-added="feelingAdded"
        ></MeasureFeeling>
      </template>
    </ModalSlide>
  </div>
</template>

<script>
import moment from "moment";

import { mapGetters } from "vuex";

import { PupilService } from "@/services/pupil.service";
import { HealthService } from "@/services/health.service";
import { WellbeingService } from "@/services/wellbeing.service";

import { pupilMixin } from "@/mixins/pupilMixin.js";
import { calendarYearList } from "@/assets/js/utils";

const ModalSlide = () => import("@/components/ModalSlide.vue");

const innertopbar = () => import("@/components/InnerTopBar.vue");

const ClassDropdown = () => import("@/components/pupil/ClassDropdown.vue");

const Pagination = () => import("@/components/helpers/Pagination.vue");
const PupilFilterModal = () => import("@/components/helpers/PupilFilter.vue");
const FilterBar = () => import("@/components/FilterBarNavigation.vue");

const MeasureFeeling = () =>
  import("@/components/selfassess/MeasureFeeling.vue");

const doublePicker = () => import("@/components/helpers/DoublePicker.vue");

export default {
  name: "pupils",
  mixins: [pupilMixin],
  props: {
    workout: { type: Object, required: true },
  },
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
    }),
    contentImage() {
      let value = this.workout.key_value;
      return require("@/assets/images/health/icons/" + value + ".png");
    },
    getBackgroundColor() {
      if (
        this.workout.color_hash != undefined &&
        this.workout.color_hash.length != 0
      ) {
        const hex = "#" + this.workout.color_hash;
        const r = parseInt(hex.slice(1, 3), 16);
        const g = parseInt(hex.slice(3, 5), 16);
        const b = parseInt(hex.slice(5, 7), 16);

        return "rgba(" + r + "," + g + "," + b + ",0.5)";
      } else {
        return "#fed7d7";
      }
    },
    title() {
      return this.workout != undefined ? this.workout.title : "";
    },
    selectedMonthTitle() {
      let date = moment(this.selectedDate, "YYYY-MM-DD");
      return "Week " + date.week() + ", " + date.format("MMMM, YYYY");
    },
    weekView() {
      let vm = this;
      var weekStart = vm.selectedDate.clone().startOf("isoweek").utcOffset(0);
      var days = [];

      for (var i = 1; i <= 7; i++) {
        let d = moment(moment(weekStart).add(i, "days"), "YYYY-MM-DD");
        days.push(d);
      }

      return days.map((d) => {
        return {
          date: d,
          month: d.format("MM"),
          dayOfWeek: d.format("ddd"),
          dateOfDay: d.format("DD"),
          color: "#DBF0F6",
        };
      });
    },
    hasMorePages() {
      return this.pagination.has_more === true;
    },
    totalResultsCount() {
      return this.pagination.total_count;
    },
    totalPages() {
      return this.pagination.total_pages;
    },
    componentLoaded() {
      return this.filteredList.length > 0;
    },
    showMessage() {
      return this.msg != undefined && this.msg.length > 0;
    },
    searchValue() {
      return this.search;
    },
    filteredList() {
      let vm = this;
      let count = this.results.length;

      let data = vm.pupils.map((pp) => {
        let mm = vm.results.filter(
          (m) => m.register_identifier === pp.identifier
        );
        let object = {
          pupil: pp,
          measures: mm,
        };
        return object;
      });

      return _.orderBy(data, [vm.sortBy, "pupil.name"], [vm.sortDirection]);
    },
    filterHasValues() {
      var value = this.filterValue;
      if (
        value.group != undefined ||
        value.years != undefined ||
        value.types != undefined ||
        (value.tags != undefined && value.length > 2)
      ) {
        return true;
      }
    },
    classSelectedValue() {
      return this.filterValue.group;
    },
  },
  data() {
    return {
      dates: [],
      selectedDate: moment(),
      filterIsVisible: false,
      pupils: [],
      tasks: [],
      results: [],
      dataTypes: [],
      loading: false,
      errored: false,
      page: 1,
      pageSize: 48,
      currentPage: 1,
      pagination: {},

      selectedDataType: {},
      search: "",
      filterValue: {},

      sortBy: "pupil.name",
      sortDirection: "asc",

      showModalSelfAssess: false,
      selectedPupil: undefined,
      selectedMeasurement: undefined,
      selectedFeeling: undefined,
      feelings: [],
    };
  },
  created() {
    if (this.workout == undefined) {
      this.closeWindow();
      return;
    }

    this.dataTypes = [
      { id: 3, title: "Duration", key: "duration", icon: "fa-clock" },
      { id: 1, title: "Steps", key: "steps", icon: "fa-shoe-prints" },
    ];
    this.selectedDataType = this.dataTypes.filter(
      (t) => t.id === this.workout.type.id
    )[0];
    this.fetchResults();
  },
  mounted() {
    this.searchPupils();
    this.getSurveys();
    this.dates = this.selectedDate;
  },
  methods: {
    fetchResults() {
      HealthService.getMeasurements(this.workout.id, this.selectedDataType.key)
        .then((response) => (this.results = response.data.data))
        .catch((err) => {
          this.errored = true;
        });
    },
    searchPupils() {
      this.loading = true;

      PupilService.getWithFilter(this.filterValue, this.page, this.pageSize)
        .then((response) => this.buildPupils(response.data))
        .catch((err) => {
          console.log("pupils " + err);
          this.errored = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    buildPupils(data) {
      this.pupils = data.data;
      this.pagination = data.meta.pagination;
    },
    getSurveys() {
      WellbeingService.getWorkoutAreaSurveys()
        .then((response) => this.fetchWorkoutFeelings(response.data.data))
        .catch((err) => {
          console.log("Surveys " + err);
          this.errored = true;
        });
    },
    fetchWorkoutFeelings(data) {
      let survey = data[0];
      WellbeingService.getWorkoutSurveyReplies(this.workout.id, survey)
        .then((response) => (this.feelings = response.data.data))
        .catch((err) => {
          console.log("feelings " + err);
          this.errored = true;
        });
    },
    checkPupilOutcome(pupil, task) {
      let finds = this.results.filter((grade) => {
        return (
          grade.register_identifier === pupil.identifier &&
          grade.task_id === task.id
        );
      });
      return finds;
    },
    hasOutcome(pupil, task) {
      if (this.checkPupilOutcome(pupil, task).length === 0) {
        return "fas fa-times-circle text-gray-300";
      } else {
        return "fas fa-check-circle text-green-400";
      }
    },
    showFilter() {
      this.filterIsVisible = !this.filterIsVisible;
    },
    updateFilteredClass(value) {
      if (value != undefined) {
        this.filterValue.group = value;
      } else {
        this.filterValue.group = {};
      }

      this.showMore({ page: 1, size: this.pageSize });
    },
    applyFilter(filters) {
      this.filterValue = filters;
      this.updateFilteredClass(filters.group);

      this.showFilter();
      this.showMore({ page: 1, size: this.pageSize });
    },
    setSearchValue(value, time = 300) {
      this.search = value;
      this.filterValue.title = this.search;

      let vm = this;
      if (vm.search.length === 0 || vm.search.length >= 1) {
        clearTimeout(vm.timeout);
        vm.timeout = setTimeout(() => {
          vm.showMore({ page: 1, size: this.pageSize });
        }, time);
      }
    },
    showMore({ page, size }) {
      this.page = page;
      this.currentPage = page;
      this.pageSize = size;
      this.searchPupils();
      window.scrollTo(0, 0);
    },
    sort(s) {
      if (s === this.sortBy) {
        this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
      }
      this.sortBy = s;
    },
    closeWindow() {
      this.$router.push({ path: "/health/measures" });
      window.scrollTo(0, 0);
    },
    colIsEven(col) {
      return col % 2 == 0;
    },
    moveToday() {
      this.selectedDate = moment();
      this.dates = this.selectedDate;
    },
    changeSelectedDataType(type) {
      this.selectedDataType = type;
      this.fetchResults();
    },
    getMeasuresForDay(measures, day) {
      var filtered = measures.filter((measure) => {
        let filtered = true;

        let date = moment(
          moment(measure.measured_date).utcOffset(0),
          "YYYY-MM-DD"
        );
        filtered = day.date.isSame(date);
        return filtered;
      });

      return filtered;
    },
    presetValue(measures, day) {
      let filtered = this.getMeasuresForDay(measures, day);
      let result = filtered.reduce((a, b) => a + b.recorded_value, 0);
      return result > 0 ? result : "";
    },
    isSelectedDate(date) {
      let selected = moment(this.selectedDate, "YYYY-MM-DD");
      let compared = moment(date, "YYYY-MM-DD");
      return moment(selected).isSame(compared, "day");
    },
    removeFromCount() {
      let value = this.count - 1;
      if (value >= 0) {
        this.count = this.count - 1;
      }
    },
    addToCount() {
      this.count = this.count + 1;
    },
    dayClick(day, jsEvent) {
      console.log("dayClick", day, jsEvent);

      this.selectedDate = moment(day.id, "YYYY-MM-DD");
      this.dates = [this.selectedDate];
    },
    handleFocusout(e, cell, day) {
      let value = e.target.value;
      if (value === "") {
        return;
      }

      let filtered = this.getMeasuresForDay(cell.measures, day);

      if (filtered.length > 0) {
        let result = filtered[0];
        result.recorded_value = parseInt(value);
        (result.health_data_type_id = this.selectedDataType.id),
          HealthService.updateMeasure(result)
            // .then((response) => this.completion(true))
            .catch((err) => {
              console.log(err);
            });
      } else {
        this.saveMeasure(cell.pupil, value, day);
      }
    },
    saveMeasure(pupil, value, day) {
      let vm = this;
      let calendarYear = calendarYearList().find((y) => y.current === true);
      let payload = {
        register_identifier: pupil.identifier,
        health_workout_id: this.workout.id,
        recorded_value: parseInt(value),
        health_data_type_id: this.selectedDataType.id,
        health_source_id: 1,
        measured_date: moment(day.date).format("YYYY-MM-DDTHH:mm:ssZ"),
        calendar_schoolyear: calendarYear.value,
      };

      HealthService.addMeasure(payload)
        .then((response) => {
          payload.identifier = response.data.identifier;
          vm.results.push(payload);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    addSelfAssess(cell, day) {
      let filtered = this.getMeasuresForDay(cell.measures, day);
      if (filtered.length === 0) {
        return;
      }

      this.selectedPupil = cell.pupil;
      this.selectedMeasurement = filtered[0];
     
      let feels = this.findFeeling(filtered[0]);
      if (feels.length > 0) {
        this.selectedFeeling = feels[0];
      } else {
        this.selectedFeeling = undefined
      }

      this.showModalSelfAssess = true;
    },
    closeSelfAssess() {
      this.selectedPupil = undefined;
      this.selectedMeasurement = undefined;
      this.showModalSelfAssess = false;
    },
    feelingAdded() {
      this.getSurveys();
      this.closeSelfAssess();
    },
    findFeeling(measure) {
      return this.feelings.filter((f) => {
        return f.measurement_identifier === measure.identifier;
      });
    },
    hasFeeling(cell, day) {
      let filtered = this.getMeasuresForDay(cell.measures, day);
      if (filtered.length === 0) {
        return;
      }

      return this.findFeeling(filtered[0]).length > 0;
    },
  },
  components: {
    PupilFilterModal,
    FilterBar,
    Pagination,
    ClassDropdown,
    innertopbar,
    MeasureFeeling,
    ModalSlide,
  },
};
</script>

<style scoped>
.table-wrapper td {
  padding-left: 0em !important;
  padding-right: 0em !important;
}

.count-button {
  @apply text-gray-300 bg-opacity-75 text-base appearance-none outline-none cursor-pointer mt-1;
}

input[type="text"] {
  padding-left: 0rem;
  padding-right: 1rem;
  padding-top: 0rem;
  padding-bottom: 0rem;
  border-radius: 0.25rem;
  margin-top: 0rem;
  border-width: 0px;
  width: 100%;
}
</style>
